/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select/creatable";

import { ModalContext } from "../../context/modal";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { customStyles } from "../../style/selectStyles";

function NewBot({ open, populateTable, data, spreadAccounts }) {
	const inputRef = useRef(null);
	const { handleOpenModal } = useContext(ModalContext);
	const [account, setAccount] = useState({});
	const [linkedAccount, setLinkedAccount] = useState({});

	async function handleNewBot() {
		try {
			await authApi.post(`/bot-builder/new`, {
				botName: inputRef?.current.value,
				account: account.value,
				linkedAccount: linkedAccount.value,
			});
			toast.success("Bot criado com sucesso", TOASTIFY_OPTIONS);
			populateTable();
			handleOpenModal();
		} catch (error) {
			toast.error("Erro ao editar bot", TOASTIFY_OPTIONS);
		}
	}

	return (
		<Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
			<Modal.Header closeLabel="" closeButton>
				<Modal.Title>Cadastrar Bot</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<MyModalBody>
					<div>
						<label htmlFor="">Conta</label>
						<Select
							styles={customStyles}
							placeholder="Ex: Bot-cliente"
							noOptionsMessage={() => "Nenhum resultado encontrado"}
							options={data.map((d) => ({
								value: d.subdomain,
								label: d.subdomain,
							}))}
							value={account}
							onChange={setAccount}
						/>
					</div>
					<div>
						<label htmlFor="">Nome do bot</label>
						<MyModalInput
							name="name"
							ref={inputRef}
							placeholder="ex: Bot-cliente"
						/>
					</div>

					<div>
						<label htmlFor="">Conta spread.chat</label>
						<Select
							styles={customStyles}
							placeholder="Ex: ZOPE"
							noOptionsMessage={() => "Nenhum resultado encontrado"}
							options={spreadAccounts.map((d) => ({
								value: d._id,
								label: d.name,
							}))}
							value={linkedAccount}
							onChange={setLinkedAccount}
						/>
					</div>
				</MyModalBody>
			</Modal.Body>
			<Modal.Footer>
				<DefaultButton onClick={handleNewBot}>Criar</DefaultButton>
			</Modal.Footer>
		</Modal>
	);
}

export { NewBot };
